"use strict";
/**
 * Database Record Types
 *
 * DynamoDB record structures - authoritative source of truth
 * Based on actual database schema and backend implementation
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./internal-fields"), exports);
__exportStar(require("./user"), exports);
__exportStar(require("./pattern"), exports);
__exportStar(require("./review"), exports);
__exportStar(require("./comment"), exports);
__exportStar(require("./operations"), exports);
// DatabaseOperations class - REMOVED: Use inline DB operations in Lambda code
__exportStar(require("./enriched"), exports);
__exportStar(require("./collection"), exports);
__exportStar(require("./moderation"), exports);
__exportStar(require("./snapshot"), exports); // SnapshotRecord — lean immutable content reference for patterns & projects
__exportStar(require("./user-moderation-records"), exports);
__exportStar(require("./craft-room"), exports); // PrivateMaterialRecord, CraftRoomMetadataRecord, etc.
__exportStar(require("./public-material"), exports); // PublicMaterialDisplayRecord, PublicMaterialDetailsRecord, etc.
__exportStar(require("./material-contribution"), exports);
__exportStar(require("./material-linking"), exports); // MaterialLinkSuggestion, PendingLinkConfirmationRecord, etc.
__exportStar(require("./notification"), exports); // NotificationRecord, NotificationUnreadCounterRecord
__exportStar(require("./permissions"), exports); // PermissionsRecord, BanSlot, BanScope, BanLevel, BanReasonCode
__exportStar(require("./social"), exports); // FollowRecord, FavoriteRecord
__exportStar(require("./field-suggestion"), exports); // FieldSuggestionRecord, FieldSuggestionRateLimitRecord
__exportStar(require("./appeal"), exports); // AppealRecord, AppealMessage
__exportStar(require("./visibility"), exports);
__exportStar(require("./audit"), exports); // AuditLogRecord, BlockedHashAuditRecord, HashBlockRecord
__exportStar(require("./unified-flagging"), exports); // UnifiedFlagRecord, FlagIdempotencyGuard, ModerationNoteRecord, etc.
__exportStar(require("./draft-review"), exports); // DraftReviewInvitationRecord, DraftReviewMessageRecord
__exportStar(require("./infrastructure"), exports); // ImageCacheRecord, ImageProcessingRecord, ImageUploadMetadataRecord, NotificationRetryRecord
__exportStar(require("./feedback"), exports); // FeedbackRecord, FieldSuggestionMessageRecord, SubmissionLimitRecord
__exportStar(require("./pdf"), exports); // PdfUploadRecord, PdfBlobRecord, PdfPatternRecord, PdfHashPatternLinkRecord, PdfReference, etc.
